import {ChangeDetectionStrategy, Component, DestroyRef, ElementRef, inject, ViewChild} from '@angular/core';
import {MatStep, MatStepper} from '@angular/material/stepper';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {RegistrationSelectors} from '@store/registration/registration.selectors';
import {RegistrationCreatePasswordFormComponent} from '@app/registration/create-password/registration-create-password-form.component';
import {RegistrationCompleteComponent} from '@app/registration/registration-complete/registration-complete.component';
import {RegistrationEmailFormComponent} from '@app/registration/email-form/registration-email-form.component';
import {RegistrationLookupAccountFormComponent} from '@app/registration/lookup-account-form/registration-lookup-account-form.component';
import {RegistrationVerifyEmailFormComponent} from '@app/registration/verify-email-form/registration-verify-email-form.component';
import {Store} from '@ngrx/store';
import {RegistrationVerifyEmailExpiredComponent} from '@app/registration/verify-email-expired/registration-verify-email-expired.component';
import {pollVerificationStatus, updateHeaderElements} from '@store/registration/registration.helpers';

@Component({
  selector: 'px-lookup-account',
  templateUrl: './lookup-account.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatStep, MatStepper,
    RegistrationCompleteComponent, RegistrationCreatePasswordFormComponent,
    RegistrationEmailFormComponent, RegistrationLookupAccountFormComponent, RegistrationVerifyEmailFormComponent,
    SelectPipe, RegistrationVerifyEmailExpiredComponent]
})
export class LookupAccountComponent {
  @ViewChild(MatStepper, {read: ElementRef})
  public set matStepperElementRef(elementRef: ElementRef<HTMLElement> | undefined) {
    updateHeaderElements(elementRef, this.store, this.destroyRef, true);
  }

  public readonly selectors = RegistrationSelectors.Registration;
  private readonly store = inject(Store);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    pollVerificationStatus(this.store, this.destroyRef);
  }
}
